import script from "./DevStepPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./DevStepPanel.vue?vue&type=script&setup=true&lang=js"

import "./DevStepPanel.vue?vue&type=style&index=0&id=5637d867&scoped=true&lang=css"

import exportComponent from "/Users/alberto/sites/newform/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5637d867"]])

export default __exports__